import { ProvisioningSourceFilter } from '../constants/provisioningSource.ts';
import { ProvisioningStatusFilter } from '../constants/provisioningStatus.ts';

type Filters = {
  fileName: string;
  orderNumber: string;
  uploadDateFrom: Date | null;
  uploadDateTo: Date | null;
  status: ProvisioningStatusFilter;
  source: ProvisioningSourceFilter;
  page: number;
  rowsPerPage: number;
};

export const provisioningQueries = {
  all: ['provisioning'] as const,
  inventory: ({ uploadDateFrom, uploadDateTo, ...other }: Filters) => {
    return [
      ...provisioningQueries.all,
      {
        uploadDateFrom: uploadDateFrom ?? '',
        uploadDateTo: uploadDateTo ?? '',
        ...other,
      },
    ];
  },
  downloadTemplate: ['provisioning', 'downloadTemplate'] as const,
  upload: ['provisioning', 'upload'],
};
